import { Box } from "@mui/material";

import type { FC, PropsWithChildren } from "react";

export const PageActions: FC<PropsWithChildren> = ({ children }) => (
  <Box mt={3} display="flex">
    {children}
  </Box>
);
